<template>
  <div>
    <!-- 选择按钮 -->
    <div class="row" style="gap:10px">
      <button class="button ghost" @click="triggerSelect">
        📷 拍照/上传
      </button>
      <div class="muted small">
        已选 {{ files.length }} 张（最大 {{ maxFiles }}）
      </div>
    </div>

    <!-- 隐藏原生 input -->
    <input ref="fileInput" type="file" accept="image/*" multiple style="display:none" @change="onFileChange" />

    <!-- 图片展示列表 -->
    <div class="img-grid" style="margin-top:12px">
      <div v-for="(f, i) in files" :key="f.id" class="thumb">
        <img :src="f.preview" />
        <div class="delete" @click="remove(i)">✕</div>
      </div>

      <div v-if="files.length === 0" class="card placeholder">
        <div class="muted">暂无图片，点击“拍照/上传”添加</div>
      </div>
    </div>
  </div>
</template>

<script>
import { uploadFile } from "@/util/upload.js";

let seq = 1;
export default {
  name: "ImageUploader",

  props: {
    value: Array, // 父组件 v-model
    maxFiles: { type: Number, default: 9 }
  },
  watch: {
    value: {
      immediate: true,
      handler(v) {
        if (!v) return;
        this.files = v.map(url => ({
          id: seq++,
          preview: url, // 直接显示已有 URL
          url
        }));
      }
    }
  },
  data() {
    return {
      files: [] // {id, preview, url}
    };
  },

  methods: {
    triggerSelect() {
      this.$refs.fileInput.click();
    },

    async onFileChange(e) {
      const chosen = Array.from(e.target.files || []);
      if (!chosen.length) return;

      for (const rawFile of chosen) {
        if (this.files.length >= this.maxFiles) break;

        try {
          const fileUrl = await uploadFile(
            rawFile,
            "clockIn",
            rawFile.name.replace(/\.\w+$/, "")
          );
          console.log("上传成功", fileUrl);
          // 拼接完整 URL 作为预览
          const previewUrl = fileUrl.startsWith("http")
            ? fileUrl
            : `https://pinche.jafron.com/${fileUrl}`;

          const item = {
            id: seq++,
            preview: previewUrl, // 显示用
            url: previewUrl          // 提交用
          };
          this.files.push(item);
          console.log("已上传", item, this.files);
          this.emitOutput();
        } catch (err) {
          console.error("上传失败", err);
          alert("上传失败: " + err.message);
        }
      }

      e.target.value = "";
    },


    remove(i) {
      // 释放 blob URL
      const f = this.files[i];
      if (f.preview.startsWith("blob:")) {
        URL.revokeObjectURL(f.preview);
      }

      this.files.splice(i, 1);
      this.emitOutput();
    },

    emitOutput() {
      this.$emit("input", this.files.map(f => f.url));
    }
  }
};
</script>

<style scoped>
/* 样式保持原来不变 */
.row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.muted {
  color: #999;
  font-size: 13px;
}

.small {
  font-size: 13px;
}

.thumb {
  width: calc(33.333% - 8px);
  aspect-ratio: 1/1;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  margin-bottom: 8px;
}

.thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.img-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.delete {
  position: absolute;
  right: 6px;
  top: 6px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  border-radius: 50%;
  width: 26px;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.card.placeholder {
  background: #f7f7f7;
  border-radius: 8px;
  padding: 12px;
  text-align: center;
  width: 100%;
}

.button.ghost {
  background: transparent;
  color: #00aaff;
  border: 1px solid rgba(0, 160, 255, 0.3);
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 14px;
}
</style>
